import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';

import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class CalendarViewFeature implements IFlagFeature {
  name = Features.CalendarView;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
